import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://1d406d1b24e014b33202030987f63fe6@o4508845388070912.ingest.us.sentry.io/4508845394100224",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});